import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { InstrumentChartModel, TelekursPeriod } from '@zero/shared/util-models';
import { ChartOptions } from 'lightweight-charts';
import { TradingViewService } from '../services/trading-view.service';

@Directive()
export class TradingViewChartBase implements AfterViewInit, OnChanges {
  @Input() public model: InstrumentChartModel | null;

  @Output() public changePeriod = new EventEmitter<string>();

  @ViewChild('chart', { static: true }) private chart: ElementRef<HTMLDivElement>;

  public loading = true;
  public hideChart = false;
  public chartOptions: Partial<ChartOptions>;
  public TelekursPeriod = TelekursPeriod;

  #setupCompleted = false;

  public chartService = inject(TradingViewService);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.chartService.setupChart(this.chart.nativeElement, this.chartOptions);
      this.#setupCompleted = true;
    }, 0);
  }

  ngOnChanges(): void {
    if (!this.#setupCompleted) {
      return;
    }

    if (this.model.isTick && this.model.hasSetDataInitially) {
      this.chartService.updateChart(this.model);
    } else {
      this.chartService.initChart(this.model);
      this.model.hasSetDataInitially = true;
    }

    this.hideChart = this.model.hasError || this.model.series?.length === 0;

    this.loading = false;
  }

  public changeChartPeriod = (period: string): void => {
    if (period === this.model.getActivePeriod() || this.loading) {
      return;
    }

    this.loading = true;
    this.model.displaySettings = true;
    this.changePeriod.emit(period);
  };
}
